import clsx from "clsx";

import "./BrandLogo.scss";

type BrandLogoProps = {
  className?: string;
};

export const BrandLogo = ({ className }: BrandLogoProps) => (
  <span
    className={clsx("BrandLogo", className)}
    role="img"
    aria-label="DrawMind"
  >
    <img src="/logo-drawmind.png" alt="" aria-hidden="true" />
  </span>
);
